import React from 'react';
import WordDetailEditRow from './WordDetailEditRow';
import { Col, Row } from 'reactstrap';

import './WordDetailEdit.scss';

const WordDetailEdit = ({
  details,
  onChangeDetails
}) => {
  const handleAdd = () => {
    onChangeDetails([
      ...details,
      {
        type: {},
        theme: {},
        mean: '',
      }
    ]);
  };

  const handleRemove = (index) => {
    const clonedDetails = [...details];
    clonedDetails.splice(index, 1);

    onChangeDetails(clonedDetails);
  };

  const handleChangeDetail = (index, detail) => {
    const clonedDetails = [...details];
    clonedDetails[index] = detail;

    onChangeDetails(clonedDetails);
  };

  return (
    <Row style={{
      width: '100%',
      margin: 0
    }}>
      <Row style={{
        width: '100%',
        margin: '5px 0'
      }}>
        <p className="word-detail-vertical-middle word-detail-row-number">#</p>
        <Col md={6} lg={2} style={{ padding: 0 }}>
          <p className="word-detail-vertical-middle text-center">품사</p>
        </Col>
        <Col md={6} lg={4}>
          <p className="word-detail-vertical-middle text-center">주제</p>
        </Col>
        <Col md={10} lg={5} style={{
          paddingLeft: 0,
          paddingRight: '5px'
        }}>
          <p className="word-detail-vertical-middle text-center">뜻</p>
        </Col>
        <Col md={2} lg={1} style={{
          padding: 0,
          margin: 'auto 0',
          textAlign: 'right'
        }}>
          <p className="word-detail-vertical-middle text-center">추가/제거</p>
        </Col>
      </Row>
      {details.map((detail, index) => (
        <WordDetailEditRow
          key={index}
          count={index + 1}
          detail={detail}
          onChangeDetail={(detail) => handleChangeDetail(index, detail)}
          onClickAdd={handleAdd}
          onClickRemove={() => handleRemove(index)}
          showAddBtn={details.length - 1 === index}
          showRemoveBtn={details.length > 1}
        />
      ))}
    </Row>
  );
};

export default WordDetailEdit;
